(() => {
  function setup() {
    document.querySelectorAll('[data-shop-all]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const filters = [...root.querySelectorAll('[data-shop-filter]')];
      const products = [...root.querySelectorAll('[data-shop-category]')];
      function update() {
        const requested = location.hash.slice(1);
        // Preserve existing category links, including the old #equipment retail link.
        const selected = filters.find(button => button.dataset.shopFilter === requested)
          || filters.find(button => (button.dataset.shopCategories || '').split(',').includes(requested))
          || filters.find(button => button.dataset.shopFilter === 'all');
        const active = selected.dataset.shopFilter;
        const categories = (selected.dataset.shopCategories || active).split(',');
        filters.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
        products.forEach(product => {
          const memberships = [product.dataset.shopCategory, ...(product.dataset.shopExtraCategories || '').split(',')];
          product.hidden = active !== 'all' && !memberships.some(category => categories.includes(category));
        });
        const count = products.filter(product => !product.hidden).length;
        root.querySelector('[data-shop-count]').textContent = `${count} ${count === 1 ? 'product' : 'products'}`;
        root.querySelector('[data-equipment-note]').hidden = !categories.includes('equipment');
      }
      filters.forEach(button => button.addEventListener('click', () => {
        const category = button.dataset.shopFilter;
        history.pushState(null, '', location.pathname + location.search + (category === 'all' ? '' : '#' + category));
        update();
      }));
      window.addEventListener('popstate', update);
      window.addEventListener('hashchange', update);
      root.querySelector('.jb-shop-filters').hidden = false;
      update();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
